import { z } from "zod";
/** Request schema for `/saveBattleReport` — toggles a battle report's saved state. */
export const SaveBattleReportSchema = z.object({
    logId: z.string().min(1),
    saved: z.boolean(),
});
//# sourceMappingURL=flightLog.schemas.js.map